import ResetPasswordModal from './component'

export default ResetPasswordModal 